import { KindQuotaEntity } from '@eastcoal/api/system/interface'
import { queryKindApi } from '@eastcoal/api/system/kind/queryKind'
import { QuotaEntity } from '@eastcoal/api/trade/interface'

import { RemoteSelect } from '@eastcoal/common/components/RemoteSelect'

import { connect, mapReadPretty } from '@eastcoal/formily/exports/react'

import { QuotaSelectProps } from './interface'

const resolveOption = (value?: KindQuotaEntity[]) => {
  return value?.map(item => ({
    label: item.name,
    value: item.name
  }))
}

const getOptionValue = (value: QuotaEntity) => `${value.name}`

const queryQuotasApi = async ({ kindId }: { kindId?: string } = {}) => {
  const res = await queryKindApi({ id: kindId })
  return res.quotas ?? []
}

const Component = ({
  value,
  onChange,
  disabled,
  mode,
  kindId
}: QuotaSelectProps) => {
  return (
    <RemoteSelect
      api={queryQuotasApi}
      disabled={disabled}
      getOptionValue={getOptionValue}
      mode={mode}
      readyRequest={!!kindId}
      refreshDeps={[kindId]}
      resolveOptions={resolveOption}
      value={value}
      requestParams={{
        kindId
      }}
      onChange={onChange}
    />
  )
}

export const QuotaSelect = connect(
  Component,
  mapReadPretty(Component, {
    disabled: true
  })
)
